import React from 'react';

export const ProductIntroMobile = {
  title: 'Browse Homes by Product',
  mobile_description:
    'Looking for a specific home layout ? Explore all of our incredible floorplans, each completely customizable to suit your needs.',
};

export const ProductInProductIntroMobile = {
  title: 'Explore \nProducts',
  mobile_description:
    'From 2-bedroom apartments to 5-bedroom earth-sheltered duplex units, Total Environment offers a lot of options. Each option may be available in multiple variants. Contact us today to know more.',
};

export const ProducttInProjectsIntroMobile = {
  title: 'Other Floorplans \nYou Might Like',
  mobile_description:
    'Every Total Environment home is part of a product family that has been carefully considered, designed and crafted. To make your home beautiful and liveable, we have thoughtfully conceived and planned every single detail, from construction materials to gardens to furniture. \n\nA Total Environment home is all about inspired living.',
};

export const ProductIntro = {
  // heading: 'Our Projects are Made of Products',
  subHeading: 'Browse Homes by Product',
  description:
    'Looking for a specific home layout ? Explore all of our incredible products, each completely customizable to suit your needs.',
};

export const ProductInProjectIntro = {
  heading: 'This Project is Made of Products',
  subHeading: 'Explore Products',
  description:
    'Looking for a specific home layout? Explore all of our incredible floorplans, each completely customizable to suit your needs.. \n\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae a. Maecenas magna tellus, convallis a vulputate vitae, consectetur id nisi. Nullam ullamcorper blandit dictum.',
};

export const ProjectInProjectsIntro = {
  heading: 'More Home Options',
  subHeading: 'Other Products You Might Like',
  description:
    'Every Total Environment home is part of a product family that has been carefully considered, designed and crafted. To make your home beautiful and liveable, we have thoughtfully conceived and planned every single detail, from construction materials to gardens to furniture. \n\nA Total Environment home is all about inspired living.',
};
